import OCTContextBase from "./octContextBase";
import store from "../store";
import { octThicknessGradient, octColorSettings, generatePalette } from "../canvas/canvasUtils";
import { COLOR_TYPE } from "../config/config";

export default class RasterContext extends OCTContextBase{
  constructor(group, exam, imgKey){
    super(group, exam, "rasterBrowserBody", "Cirrus Browser", imgKey);
    
    this.loadComposite = false;
    this.loadHD = false;

    this.octColorSettings = octColorSettings();

    this.slicePalette = octThicknessGradient;

    if (store.getters.userPrefCirrusView == COLOR_TYPE.color)
      this.toggleColorPalette();
  }

  toggleInverted() {
    this.octColorSettings.isInverted = !this.octColorSettings.isInverted;
    if (this.octColorSettings.isInverted) this.octColorSettings.colorPalette = null;
  }
  toggleColorPalette() {
    this.octColorSettings.isInverted = false;
    if (this.octColorSettings.colorPalette) this.octColorSettings.colorPalette = null;
    else this.octColorSettings.colorPalette = this.getSlicePalette();
  }
  getSlicePalette() {
    return generatePalette(this.slicePalette);
  }
}